// extracted by mini-css-extract-plugin
export default {"root":"InputLabel_root__yOlS0","icon":"InputLabel_icon__y3uOi","container":"InputLabel_container__Jhc5l"};